var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-drawer",
    {
      attrs: {
        "append-to-body": "",
        visible: _vm.drawerVisible,
        "with-header": false,
        direction: "rtl",
        size: "680px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.drawerVisible = $event
        },
      },
    },
    [
      _vm.drawerVisible
        ? _c("div", { staticClass: "container" }, [
            _c(
              "div",
              { staticClass: "card" },
              [
                _c("RoomTypeList", {
                  attrs: { "order-detail-list": _vm.orderDetailList },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "tab-bar" }, [
              _c(
                "div",
                {
                  staticClass: "tab-item",
                  class: { active: _vm.activeTab === "cancel" },
                  on: {
                    click: function ($event) {
                      _vm.activeTab = "cancel"
                    },
                  },
                },
                [_vm._v("减少数量")]
              ),
              _c(
                "div",
                {
                  staticClass: "tab-item",
                  class: { active: _vm.activeTab === "add" },
                  on: {
                    click: function ($event) {
                      _vm.activeTab = "add"
                    },
                  },
                },
                [_vm._v("增加数量")]
              ),
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeTab === "cancel",
                    expression: "activeTab === 'cancel'",
                  },
                ],
                staticClass: "card",
              },
              [
                _c("div", { staticClass: "section-title" }, [
                  _vm._v("减少数量（取消）"),
                ]),
                _vm._l(_vm.cancelList, function (item, idx) {
                  return _c(
                    "div",
                    { key: idx, staticClass: "edit-row" },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "200px" },
                          attrs: { placeholder: "选择房型", size: "medium" },
                          on: {
                            change: (val) => _vm.onCancelRoomChange(val, idx),
                          },
                          model: {
                            value: item.roomId,
                            callback: function ($$v) {
                              _vm.$set(item, "roomId", $$v)
                            },
                            expression: "item.roomId",
                          },
                        },
                        _vm._l(_vm.cancelRoomOptions, function (opt) {
                          return _c("el-option", {
                            key: opt.value,
                            attrs: { label: opt.label, value: opt.value },
                          })
                        }),
                        1
                      ),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "220px" },
                          attrs: {
                            placeholder: "请先选房型",
                            size: "medium",
                            disabled: !item.roomId,
                          },
                          on: {
                            change: (val) => _vm.onCancelDateChange(val, idx),
                          },
                          model: {
                            value: item.date,
                            callback: function ($$v) {
                              _vm.$set(item, "date", $$v)
                            },
                            expression: "item.date",
                          },
                        },
                        _vm._l(item.availableDates || [], function (d) {
                          return _c("el-option", {
                            key: d,
                            attrs: { label: d, value: d },
                          })
                        }),
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "qty-wrap" },
                        [
                          _c("el-input", {
                            staticStyle: { width: "120px" },
                            attrs: {
                              disabled: !item.roomId || item.loadingQty,
                              size: "medium",
                              type: "number",
                              placeholder: "请输入",
                            },
                            on: {
                              input: function ($event) {
                                return _vm.onCancelQtyInput(idx)
                              },
                            },
                            model: {
                              value: item.quantity,
                              callback: function ($$v) {
                                _vm.$set(item, "quantity", _vm._n($$v))
                              },
                              expression: "item.quantity",
                            },
                          }),
                          !item.loadingQty
                            ? _c("span", { staticClass: "qty-hint" }, [
                                _vm._v(_vm._s(_vm.getCancelQtyHint(idx))),
                              ])
                            : _vm._e(),
                          item.loadingQty
                            ? _c("span", { staticClass: "qty-hint loading" }, [
                                _vm._v("查询中..."),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm.cancelList.length > 1
                        ? _c("i", {
                            staticClass: "el-icon-close delete-btn",
                            on: {
                              click: function ($event) {
                                return _vm.removeCancelItem(idx)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                _c(
                  "div",
                  {
                    staticClass: "add-item-btn",
                    on: { click: _vm.addCancelItem },
                  },
                  [
                    _c("i", { staticClass: "el-icon-plus" }),
                    _vm._v(" 添加取消项"),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "submit-row" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "submit-btn btn-red",
                        attrs: { type: "primary" },
                        on: { click: _vm.confirmCancel },
                      },
                      [_vm._v("确认取消")]
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeTab === "add",
                    expression: "activeTab === 'add'",
                  },
                ],
                staticClass: "card",
              },
              [
                _c("div", { staticClass: "section-title" }, [
                  _vm._v("增加数量（询价）"),
                ]),
                _vm._l(_vm.addList, function (item, idx) {
                  return _c(
                    "div",
                    { key: idx, staticClass: "edit-row" },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "200px" },
                          attrs: { placeholder: "选择房型", size: "medium" },
                          on: {
                            change: (val) => _vm.onAddRoomChange(val, idx),
                          },
                          model: {
                            value: item.roomId,
                            callback: function ($$v) {
                              _vm.$set(item, "roomId", $$v)
                            },
                            expression: "item.roomId",
                          },
                        },
                        _vm._l(_vm.inquiryRoomOptions, function (opt) {
                          return _c("el-option", {
                            key: opt.value,
                            attrs: { label: opt.label, value: opt.value },
                          })
                        }),
                        1
                      ),
                      _c("el-date-picker", {
                        staticStyle: { width: "220px" },
                        attrs: {
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          placeholder: "选择日期",
                          size: "medium",
                          "picker-options": _vm.datePickerOptions,
                        },
                        on: { change: (val) => _vm.onAddDateChange(val, idx) },
                        model: {
                          value: item.date,
                          callback: function ($$v) {
                            _vm.$set(item, "date", $$v)
                          },
                          expression: "item.date",
                        },
                      }),
                      _c("el-input", {
                        staticStyle: { width: "120px" },
                        attrs: {
                          size: "medium",
                          type: "number",
                          placeholder: "请输入",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.onAddQtyInput(idx)
                          },
                        },
                        model: {
                          value: item.quantity,
                          callback: function ($$v) {
                            _vm.$set(item, "quantity", _vm._n($$v))
                          },
                          expression: "item.quantity",
                        },
                      }),
                      _vm.addList.length > 1
                        ? _c("i", {
                            staticClass: "el-icon-close delete-btn",
                            on: {
                              click: function ($event) {
                                return _vm.removeAddItem(idx)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                _c(
                  "div",
                  {
                    staticClass: "add-item-btn",
                    on: { click: _vm.addAddItem },
                  },
                  [
                    _c("i", { staticClass: "el-icon-plus" }),
                    _vm._v(" 添加增订项"),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "submit-row" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "submit-btn btn-dark",
                        attrs: { type: "primary" },
                        on: { click: _vm.confirmInquiry },
                      },
                      [_vm._v("立即询价")]
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }